<template>
	<div class="menu-group">
		<h2 v-if="title" class="menu-group-title">{{title}}</h2>
		<slot/>
	</div>
</template>

<script>
export default {
	name: 'TMenuGroup',
	props: { title: String }
};
</script>

<style lang="scss" scoped>
	@import '~@/components/evergreen/scss/text';
	@import '~@/components/evergreen/scss/colors';

	.menu-group {
		box-sizing: border-box;
		padding-top: 8px;
		padding-bottom: 8px;
	}
	.menu-group hr {
		margin: 2px 5px;
		border: none;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
	}
	.menu-group-title {
		@extend %font-families-ui;
		letter-spacing: 0.6px;
		font-size: 11px;
		font-weight: 400;
		line-height: 16px;
		letter-spacing: 0.6px;
		color: get-color($text, 'muted');
		text-transform: uppercase;
		margin-left: 16px;
		margin-right: 16px;
		margin-top: 8px;
		margin-bottom: 8px;
	}
</style>
